<template>
    <div>
        <Loading :value="loading"></Loading>
        <!-- RACOURCIS -->
        <v-card>
            <v-card-title>
                <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item
                            icons
                            router
                            :to="item.path"
                            v-for="item in racourcis"
                            :key="item.text"
                            :disabled="item.disabled"
                    >{{ item.text }}
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-title>
        </v-card>
        <br/>

        <v-layout row class="text-xs-center">
            <!-- Graph -->
            <v-flex xs6></v-flex>

            <v-flex xs6></v-flex>
        </v-layout>

        <v-layout row>
            <!-- <v-flex xs12 md2 mr-2>
              <v-card>
                <v-toolbar color="cyan" dark>
                  <v-toolbar-title>Informations</v-toolbar-title>
                </v-toolbar>
                <v-list subheader two-line style="mtravauxvfgfgfgfdargin-top:10px;">
                  <v-list-tile style="height:120px;">
                    <v-list-tile-content style="height:180px;margin-top:10px; margin-bottom:5px;">
                      <v-list-tile-title
                        style="margin-top:50px;margin-bottom:10px;text-align:center;"
                      >EVOLUTION</v-list-tile-title>
                      <v-list-tile-sub-title style="height:150px;text-align:center;">
                        <div>
                          <v-progress-circular
                            :size="100"
                            :width="15"
                            :rotate="360"
                            :value="60"
                            color="primary"
                          >60%</v-progress-circular>
                        </div>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Reference</v-list-tile-title>
                      <v-list-tile-sub-title>Ref-rgsdvsdvsdvsdv</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Projet</v-list-tile-title>
                      <v-list-tile-sub-title>Projet de gestion</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Chantier</v-list-tile-title>
                      <v-list-tile-sub-title>CHANTION DE CONSTRUCTION GOHIHIHIIHTA FFFL SGSFGSFS</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Type de projet</v-list-tile-title>
                      <v-list-tile-sub-title>Projet de rehabilitaion</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Date debut</v-list-tile-title>
                      <v-list-tile-sub-title>Mercredi 26 novembre 2019</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Date fin</v-list-tile-title>
                      <v-list-tile-sub-title>Mercredi 26 novembre 2020</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Situation géographique</v-list-tile-title>
                      <v-list-tile-sub-title>Cocody</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Responsable</v-list-tile-title>
                      <v-list-tile-sub-title>Adje</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Responsable</v-list-tile-title>
                      <v-list-tile-sub-title>Adje</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Date enregistrement</v-list-tile-title>
                      <v-list-tile-sub-title>12-04-2019</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>Date de fin</v-list-tile-title>
                      <v-list-tile-sub-title>12-04-2022</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>-->

            <!--BILAN FINANCIERS SUR L'ANNEE-->
            <v-flex xs12>
                <v-layout row>
                    <v-card style="width:100%">
                        <v-card-text fluid grid-list-md>
                            <h3>Champs de recherche</h3>
                            <v-divider class="mb-2"></v-divider>
                            <v-layout row class="mb-4 mt-2">
                                <v-flex xs12 class="mt-2">
                                    <el-form
                                            id="formSearch"
                                            :model="formSearch"
                                            :rules="rulesForm"
                                            :inline="true"
                                            ref="formSearch"
                                            class="demo-form-inline"
                                    >
                                        <el-form-item label="Projet" prop="projet">
                                            <el-select
                                                    v-model="formSearch.projet"
                                                    name="projet"
                                                    placeholder="projet"
                                                    style="width: 100%"
                                                    @change="selectProjet"
                                            >
                                                <el-option
                                                        v-for="item in listeProjet"
                                                        :key="item.id"
                                                        :label="item.libelle"
                                                        :value="item.id"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label="Chantier" prop="chantier">
                                            <el-select
                                                    clearable
                                                    v-model="formSearch.chantier"
                                                    name="chantier"
                                                    placeholder="chantier"
                                                    style="width: 100%"
                                            >
                                                <el-option
                                                        v-for="item in listeChantier"
                                                        :key="item.id"
                                                        :label="item.libelle"
                                                        :value="item.id"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label=" ">
                                            <el-button
                                                    type="primary"
                                                    :disabled="disableBtnRecherche"
                                                    @click.stop="loadBilan()"
                                            >Rechercher
                                            </el-button>
                                        </el-form-item>
                                    </el-form>
                                </v-flex>
                            </v-layout>

                            <!-- INFORMATIONS PROJET -->
                            <v-layout row class="elevation-3 pt-2 pl-2 pr-2">
                                <v-flex xs12>
                                    <h3>Informations générales</h3>
                                    <v-divider class="mb-4"></v-divider>

                                    <v-layout wrap>
                                        <!--COLONNE 1-->
                                        <v-flex xs4 class="mr-4">
                                            <v-layout row>
                                                <v-flex xs3>Projet</v-flex>
                                                <v-flex xs9 class="text-xs-right  title">{{info.libelleProjet}}</v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs3>Type de projet</v-flex>
                                                <v-flex xs9 class="text-xs-right title">{{info.typeProjet}}</v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs3>Chantier</v-flex>
                                                <v-flex xs9 class="text-xs-right title">{{info.libelleChant}}</v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs3>Responsable</v-flex>
                                                <v-flex xs9 class="text-xs-right title">{{info.libelleResponsable}}
                                                </v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>
                                        </v-flex>

                                        <!--COLONNE 2-->
                                        <v-flex xs4 >
                                            <v-layout row>
                                                <v-flex xs3>Date début</v-flex>
                                                <v-flex xs9 class="text-xs-right title">{{info.dateDbt}}</v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs3>Date fin</v-flex>
                                                <v-flex xs9 class="text-xs-right title">{{info.dateFin}}</v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs4>Situation géographique</v-flex>
                                                <v-flex xs8 class="text-xs-right title">{{info.situation}}</v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs3>Date enregistrement</v-flex>
                                                <v-flex xs9 class="text-xs-right title">{{info.enregistre}}</v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>
                                        </v-flex>

                                        <!--COLONNE 3-->
                                        <v-flex xs3 class="text-xs-center">

                                            <v-progress-circular
                                                    :size="150"
                                                    :width="15"
                                                    :rotate="360"
                                                    :value="info.evolution"
                                                    color="orange"
                                            >{{parseFloat(info.evolution).toFixed(2)}} %
                                            </v-progress-circular>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex xs12 class="mt-4">
                                    <h3>Résultat compte d'exploitation</h3>
                                    <v-divider class="mb-2"></v-divider>
                                    <!-- INFORMATIONS TAB -->
                                    <el-tabs
                                            :stretch="true"
                                            v-model="compte"
                                            type="border-card"
                                            @tab-click="handleTabClick(compte)"
                                    >
                                        <el-tab-pane>
                                            <span slot="label"><v-icon>account_balance</v-icon> Recapitulatif annuel</span>
                                            <v-flex xs12 class="text-xs-right">
                                                <v-flex>
                                                    <el-popover ref="popChantier" placement="top" width="180" trigger="hover">
                                                    <p>Veuillez choisir le format d'impression ?</p>
                                                    <div style="text-align: center; margin: 0;" align="center">
                                                            <p align="center"> <el-button
                                                        type="success"
                                                        size="mini"
                                                        @click="imprimeBudgtRecapitulatifAnnuelSimpl('PDF')"
                                                        >PDF SIMPLE</el-button>
                                                        </p>
                                                            <p align="center">
                                                        <el-button
                                                        type="primary"
                                                        size="mini"
                                                        @click="imprimeBudgtRecapitulatifAnnuel('PDF')"
                                                        >PDF DETAILLE</el-button>
                                                        </p>
                                                        <p align="center">
                                                        <el-button
                                                        type="success"
                                                        size="mini"
                                                        @click="imprimeBudgtRecapitulatifAnnuelSimpl('EXC')"
                                                        >EXC </el-button>
                                                        </p>
                                                        <!-- <p align="center">
                                                        <el-button
                                                        type="primary"
                                                        size="mini"
                                                        @click="imprimeBudgtRecapitulatifAnnuel('EXC')"
                                                        >EXC DETAILLE</el-button>
                                                        </p> -->
                                                    </div>
                                                    </el-popover>
                                                    <div>
                                                    <el-button
                                                        v-popover:popChantier
                                                        type="warning"
                                                        :disabled="disabledBtnPop"
                                                        icon="el-icon-printer"
                                                    >Rapport</el-button>
                                                    </div>
                                                </v-flex>
                                        </v-flex>
                                            <el-collapse accordion>
                                                <v-layout
                                                        wrap
                                                        class="text-xs-center"
                                                        v-for="(groupeMois, index) in bilanMensuel"
                                                        :key="index"
                                                >
                                                    <div style="width:100%">
                                                        <!-- ANNEE -->
                                                        <el-collapse-item :name="index" style="width:100%"
                                                                          class=" mb-1 pl-3 pr-3">
                                                            <template slot="title">

                                                                <v-layout row>
                                                                    <v-flex xs4 class="text-sm-left">
                                                                        <v-chip dark label  text-color="white"
                                                                                style="font-size:20px"
                                                                                color="purple">
                                                                            <v-icon left>label</v-icon>
                                                                            {{index}}
                                                                        </v-chip>
                                                                    </v-flex>
                                                                    <v-flex xs4 class="text-sm-left">
                                                                        <v-chip style="font-size:15px" label outline
                                                                                color="primary"><b>TOTAL MONTANT
                                                                            MARCHE: {{ new
                                                                            Intl.NumberFormat().format(groupeMois.totalMntPrevu)
                                                                            }} </b></v-chip>
                                                                    </v-flex>
                                                                    <v-flex xs4 class="text-sm-left">
                                                                        <v-chip style="font-size:15px" label outline
                                                                                color="primary"><b>TOTAL MONTANT
                                                                            ENGAGÉ: {{ new
                                                                            Intl.NumberFormat().format(groupeMois.totalMntDecaisse)
                                                                            }} </b></v-chip>
                                                                    </v-flex>
                                                                </v-layout>



                                                            </template>
                                                            <!-- <v-flex xs2 class="offset-xs5 mb-3 purple--text">
                                                              <h2>{{index}}</h2>
                                                              <v-divider></v-divider>
                                                            </v-flex> -->


                                                            <v-flex xs12 class="mt-3"
                                                                    v-for="(travaux, mois) in groupeMois.mois"
                                                                    :key="mois">

                                                                <span style="font-size:20px" class="blue--text"> {{mois}}-{{index}}</span>


                                                                <el-table class="elevation-1" :data="travaux"
                                                                          highlight-current-row
                                                                          :header-row-style="headerRowStyle"
                                                                          style="width: 100%" border
                                                                          :summary-method="getSummaries"
                                                                          show-summary>

                                                                    <el-table-column type="expand" >
                                                                        <template slot-scope="props" >
                                                                            <el-row class="elevation-3 pl-4 pr-4 pt-2"  >
                                                                                <el-col :span="24">
                                                                                    <div class="grid-content bg-purple mb-2">
                                                                                        <v-alert
                                                                                                :value="true"
                                                                                                outline
                                                                                                color="primary"
                                                                                                class="mb-4"
                                                                                                icon="info"
                                                                                        >Liste des tâches
                                                                                        </v-alert>
                                                                                        <div>

                                                                                            <el-table
                                                                                                    border
                                                                                                    highlight-current-row
                                                                                                    :header-row-style="headerRowStyle"
                                                                                                    :data="props.row.taches"
                                                                                                    :summary-method="getSummaries"
                                                                                                    show-summary
                                                                                                    style="width: 100%"
                                                                                            >
                                                                                                <el-table-column
                                                                                                        align="center"
                                                                                                        prop="libelle"
                                                                                                        label="DESIGNATION"></el-table-column>
                                                                                                <el-table-column
                                                                                                        align="center"
                                                                                                        prop="unite"
                                                                                                        label="UNITE"></el-table-column>
                                                                                                <el-table-column
                                                                                                        align="center"
                                                                                                        prop="prixU"
                                                                                                        label="PRIX UNITAIRE">
                                                                                                    <template
                                                                                                            slot-scope="prop1"
                                                                                                    >{{ new
                                                                                                        Intl.NumberFormat().format(prop1.row.prixU)}}
                                                                                                    </template>
                                                                                                </el-table-column>
                                                                                                <el-table-column
                                                                                                        align="center"
                                                                                                        prop="qtePrevu"
                                                                                                        label="QUANTITE PREVUE"
                                                                                                >
                                                                                                    <template
                                                                                                            slot-scope="prop2"
                                                                                                    >{{ new
                                                                                                        Intl.NumberFormat().format(prop2.row.qtePrevu)}}
                                                                                                    </template>
                                                                                                </el-table-column>
                                                                                                <el-table-column
                                                                                                        align="center"
                                                                                                        prop="qteRealise"
                                                                                                        label="QUANTITE REALISEE"
                                                                                                >
                                                                                                    <template
                                                                                                            slot-scope="prop3"
                                                                                                    >{{ new
                                                                                                        Intl.NumberFormat().format(prop3.row.qteRealise)}}
                                                                                                    </template>
                                                                                                </el-table-column>
                                                                                                <el-table-column
                                                                                                        align="center"
                                                                                                        prop="mntPrevu"
                                                                                                        label="MONTANT MARCHE"
                                                                                                >
                                                                                                    <template
                                                                                                            slot-scope="prop4"
                                                                                                    >{{ new
                                                                                                        Intl.NumberFormat().format(prop4.row.mntPrevu)}}
                                                                                                    </template>
                                                                                                </el-table-column>
                                                                                                <el-table-column
                                                                                                        align="center"
                                                                                                        prop="mntRealise"
                                                                                                        label="VALEUR REALISE"
                                                                                                >
                                                                                                    <template
                                                                                                            slot-scope="prop5"
                                                                                                    >{{ new
                                                                                                        Intl.NumberFormat().format(prop5.row.mntRealise)}}
                                                                                                    </template>
                                                                                                </el-table-column>
                                                                                            </el-table>
                                                                                        </div>

                                                                                    </div>
                                                                                </el-col>
                                                                            </el-row>
                                                                        </template>
                                                                    </el-table-column>

                                                                    <el-table-column prop="libelle"  align="center"
                                                                                     label="Travaux"></el-table-column>
                                                                    <el-table-column prop="montantPrevu"  align="center"
                                                                                     label="Montant prévu">
                                                                        <template
                                                                                slot-scope="prop"
                                                                        >{{ new
                                                                            Intl.NumberFormat().format(prop.row.montantPrevu)}}
                                                                        </template>
                                                                    </el-table-column>

                                                                    <el-table-column prop="montantRealise"  align="center"
                                                                                     label="Valeur réalisé">
                                                                        <template
                                                                                slot-scope="prop"
                                                                        >{{ new
                                                                            Intl.NumberFormat().format(prop.row.montantRealise)}}
                                                                        </template>
                                                                    </el-table-column>

                                                                    <el-table-column  align="center" prop="montantDecaisse"
                                                                                     label="Montant decaissé">
                                                                        <template
                                                                                slot-scope="prop"
                                                                        >{{ new
                                                                            Intl.NumberFormat().format(prop.row.montantDecaisse)}}
                                                                        </template>
                                                                    </el-table-column>






                                                                </el-table>

                                                            </v-flex>
                                                        </el-collapse-item>
                                                        <v-divider class="mb-2"></v-divider>

                                                    </div>


                                                </v-layout>

                                            </el-collapse>
                                        </el-tab-pane>


                                        <el-tab-pane>
                                            <span slot="label"><v-icon>library_books</v-icon> Recapitulatif travaux DQE</span>
                                            <v-layout row>
                                                <v-flex xs12>


                                                    <v-chip dark label color="purple" text-color="white">
                                                        <v-icon left>label</v-icon>
                                                        <span>Liste des travaux</span>
                                                    </v-chip>
                                                    
                                                    <v-flex xs12 class="text-xs-right">
                                                        <v-tooltip top>
                                                        <v-btn
                                                            v-if="true"
                                                            slot="activator"
                                                            color="orange"
                                                            :disabled="false"
                                                            @click.stop="imprimeProjetPDF()"
                                                            dark
                                                        >
                                                            Imprimer
                                                            <v-icon right>print</v-icon>
                                                        </v-btn>Imprimer la matrice
                                                        </v-tooltip>
                                                    </v-flex>
                                                   

                                                    <el-table

                                                            border
                                                            :header-row-style="headerRowStyle"
                                                            highlight-current-row
                                                            :data="bilanTravaux"
                                                            :summary-method="getSumm"
                                                            show-summary
                                                            style="width: 100%"
                                                    >
                                                        <el-table-column type="expand">
                                                            <template slot-scope="props">
                                                                <div>


                                                                    <v-chip dark label color="purple" text-color="white">
                                                                        <v-icon left>label</v-icon>
                                                                        <span>Liste des tâches planifiées</span>
                                                                    </v-chip>
                                                                    <el-table
                                                                            border
                                                                            highlight-current-row
                                                                            :header-row-style="headerRowStyle"

                                                                            class="elevation-2"
                                                                            :data="props.row.taches"
                                                                            :summary-method="getSummariesTache"
                                                                            show-summary
                                                                            style="width: 100%"
                                                                    >
                                                                        <el-table-column align="center" prop="libelle" sortable
                                                                                         label="DESIGNATION">

                                                                            <template
                                                                                    slot-scope="prop"
                                                                            >
                                                                                <span class="subheading black--text" > {{prop.row.libelle}}  </span>
                                                                            </template>
                                                                        </el-table-column>


                                                                        <el-table-column align="center" sortable
                                                                                prop="mntPrevu"
                                                                                label="MONTANT MARCHE"
                                                                        >
                                                                            <template
                                                                                    slot-scope="prop4"
                                                                            > 
                                                                            <el-tag class="subheading">
                                                                                {{ new Intl.NumberFormat().format(prop4.row.mntPrevu)}}
                                                                            </el-tag>
                                                                              </template>
                                                                        </el-table-column>
                                                                        <el-table-column  align="center" sortable
                                                                                prop="mntRealise"
                                                                                label="MONTANT REALISE"
                                                                        >
                                                                            <template
                                                                                    slot-scope="prop5"
                                                                            >
                                                                            <el-tag   class="subheading" type="warning">
                                                                                {{ new Intl.NumberFormat().format(prop5.row.mntRealise)}}
                                                                            </el-tag>
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column align="center"  sortable  prop="ecart" label="ECART">
                                                                            <template
                                                                                    slot-scope="prop3"
                                                                            >

                                                                                <el-tag   class="subheading":type="prop3.row.ecart < 0 ? 'danger' : 'success'">
                                                                                    {{ new Intl.NumberFormat().format(prop3.row.ecart)}}
                                                                                </el-tag>
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column  align="center" sortable  prop="evolution"
                                                                                         label="EVOLUTION(%)">
                                                                            <template
                                                                                    slot-scope="prop2"
                                                                            >

                                                                                <el-progress :percentage="Number.parseFloat(prop2.row.evolution).toFixed(2)"
                                                                                :color="Number.parseFloat(prop2.row.evolution).toFixed(2) >= 50 ? '#76FF03': 'blue'" :format="format" >
                                                                                </el-progress>

                                                                                <!-- <el-progress color="#76FF03"
                                                                                             :percentage="parseFloat(prop2.row.evolution).toFixed(2)"></el-progress> -->

                                                                            </template>
                                                                        </el-table-column>


                                                                    </el-table>
                                                                </div>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column  align="center" sortable  prop="libelle"
                                                                         label="DESIGNATION">
                                                            <template
                                                                    slot-scope="prop"
                                                            >
                                                                <span class="subheading black--text" > {{prop.row.libelle}}  </span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column align="center" sortable prop="montantPrevu" label="MONTANT MARCHE">
                                                            <template
                                                                    slot-scope="prop4"
                                                            >
                                                                <el-tag class="subheading" type="blue">
                                                                    {{ new Intl.NumberFormat().format(prop4.row.montantPrevu)}}
                                                                </el-tag>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column  align="center" sortable  prop="montantEffectif" label="MONTANT REALISE">
                                                            <template
                                                                    slot-scope="prop5"
                                                            >
                                                            <el-tag class="subheading" type="warning">
                                                                {{ new Intl.NumberFormat().format(prop5.row.montantEffectif)}}
                                                            </el-tag>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column  align="center" sortable  prop="ecart" label="ECART">
                                                            <template
                                                                    slot-scope="prop3"
                                                            >
                                                                <el-tag   class="subheading":type="prop3.row.ecart < 0 ? 'danger' : 'success'">
                                                                    {{ new Intl.NumberFormat().format(prop3.row.ecart)}}
                                                                </el-tag>

                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column  align="center" sortable prop="evolution" label="EVOLUTION(%)">
                                                            <template
                                                                    slot-scope="prop2"
                                                            >
                                                                <el-progress :percentage="Number.parseFloat(prop2.row.evolution).toFixed(2)"
                                                                :color="Number.parseFloat(prop2.row.evolution).toFixed(2) >= 50 ? '#76FF03': 'blue'" :format="format">
                                                                </el-progress>


                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                </v-flex>
                                            </v-layout>
                                        </el-tab-pane>

                                        <el-tab-pane>
                                            <span slot="label"><v-icon>account_balance_wallet</v-icon> Etat financier</span>
                                             <v-flex xs12 class="text-xs-right">
                                                        <v-tooltip top>
                                                        <v-btn
                                                            v-if="true"
                                                            slot="activator"
                                                            color="orange"
                                                            :disabled="false"
                                                            @click.stop="imprimerEtatProjetPDF()"
                                                            dark
                                                        >
                                                            Imprimer
                                                            <v-icon right>print</v-icon>
                                                        </v-btn>Imprimer état projet ou chantier
                                                        </v-tooltip>
                                                    </v-flex>
                                            <v-layout
                                                    row
                                                    v-for="(compte, index) in listeDetail"
                                                    :key="index"
                                                    class="mt-3 mb-4"
                                            >

                                                <v-flex xs12>
                                                    <v-chip dark label color="purple" text-color="white">
                                                        <v-icon left>label</v-icon>
                                                        <span>{{index}}</span>
                                                    </v-chip>

                                                    <el-table
                                                            class="mb-4"
                                                            border
                                                            highlight-current-row
                                                            :header-row-style="headerRowStyle"
                                                            :data="compte"
                                                            :summary-method="getSummCompte"
                                                            show-summary
                                                            style="width: 100%"
                                                    >

                                                        <el-table-column  type="expand">
                                                            <template slot-scope="propsArticle">
                                                                <el-row class="elevation-3 pl-4 pr-4 pt-2">

                                                                    <el-col :span="24">
                                                                        <div class="grid-content bg-purple">




                                                                            <v-chip dark label color="purple" text-color="white">
                                                                                <v-icon left>label</v-icon>
                                                                                <span>Détails facture</span>
                                                                            </v-chip>

                                                                            <el-table
                                                                                    border
                                                                                    highlight-current-row
                                                                                    :header-row-style="headerRowStyle"
                                                                                    :data="propsArticle.row.produits"
                                                                                    :summary-method="getSummaries"
                                                                                    show-summary
                                                                                    style="width: 100%"
                                                                            >
                                                                                <el-table-column prop="ref" align="center"
                                                                                                 label="REFERENCE"></el-table-column>
                                                                                <el-table-column prop="designation" align="center"
                                                                                                 label="DESIGNATION"></el-table-column>
                                                                                <el-table-column prop="qte" align="center"
                                                                                                 label="QUANTITE">
                                                                                    <template
                                                                                            slot-scope="propA1"
                                                                                    >{{ new
                                                                                        Intl.NumberFormat().format(propA1.row.qte)}}
                                                                                    </template>
                                                                                </el-table-column>

                                                                                <el-table-column prop="unite" align="center"
                                                                                                 label="UNITE"></el-table-column>
                                                                                <el-table-column prop="prixU" align="center"
                                                                                                 label="PRIX UNITAIRE">
                                                                                    <template
                                                                                            slot-scope="propA2"
                                                                                    >{{ new
                                                                                        Intl.NumberFormat().format(propA2.row.prixU)}}
                                                                                    </template>
                                                                                </el-table-column>

                                                                                <el-table-column prop="tva" align="center"
                                                                                                 label="TVA"></el-table-column>
                                                                                <el-table-column prop="remise"
                                                                                                 label="REMISE" align="center"></el-table-column>
                                                                                <el-table-column prop="total" align="center"
                                                                                                 label="TOTAL">
                                                                                    <template
                                                                                            slot-scope="propA3"
                                                                                    >
                                                                                    <el-tag class="subheading" type="warning">
                                                                                        {{ new
                                                                                        Intl.NumberFormat().format(propA3.row.total)}}
                                                                                    </el-tag>
                                                                                    </template>
                                                                                </el-table-column>
                                                                            </el-table>
                                                                        </div>
                                                                    </el-col>
                                                                </el-row>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column sortable align="center" prop="ref" label="REFERENCE">
                                                            <template
                                                                    slot-scope="prop"
                                                            > <span class="subheading black--text" > {{prop.row.ref}}  </span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column align="center" sortable  prop="designation"
                                                                         label="DESIGNATION"></el-table-column>
                                                        <el-table-column align="center" sortable  prop="qte" label="QUANTITE">
                                                            <template
                                                                    slot-scope="propq"
                                                            >{{ new Intl.NumberFormat().format(propq.row.qte)}}
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column  align="center" sortable prop="unite" label="UNITE"></el-table-column>
                                                        <el-table-column align="center" sortable prop="prixU" label="PRIX UNITAIRE">
                                                            <template
                                                                    slot-scope="prop"
                                                            >{{ new Intl.NumberFormat().format(prop.row.prixU)}}
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column align="center"  sortable prop="total" label="TOTAL FACTURE">
                                                            <template
                                                                    slot-scope="prop2"
                                                            >
                                                                <el-tag class="subheading" type="warning">
                                                                    {{ new Intl.NumberFormat().format(prop2.row.total)}}
                                                                </el-tag>


                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column  align="center" sortable  prop="total" label="TOTAL FACTURE PAYEE">
                                                            <template
                                                                    slot-scope="prop2"
                                                            >
                                                                <el-tag class="subheading" type="success">
                                                                    {{ new Intl.NumberFormat().format(prop2.row.totalPaye)}}
                                                                </el-tag>


                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column  align="center" sortable prop="total" label="TOTAL FACTURE IMPAYEE">
                                                            <template
                                                                    slot-scope="prop2"
                                                            >
                                                                <el-tag class="subheading" type="danger">
                                                                    {{ new Intl.NumberFormat().format(prop2.row.totalImpaye)}}
                                                                </el-tag>
                                                            </template>
                                                        </el-table-column>


                                                    </el-table>
                                                </v-flex>
                                            </v-layout>
                                        </el-tab-pane>


                                        <el-tab-pane label="Matériaux/Matériel utilisés">
                                            <span slot="label"><v-icon>storage</v-icon> Matériaux/Matériels utilisés</span>
                                            <v-layout
                                                    row
                                                    class="mt-3"
                                            >
                                                <v-flex xs12>
                                                    <v-chip dark label color="purple" text-color="white">
                                                        <v-icon left>label</v-icon>
                                                        <span>Matériaux/Matériels</span>
                                                    </v-chip>

                                                    <el-table
                                                            border
                                                            highlight-current-row
                                                            :header-row-style="headerRowStyle"
                                                            :data="listeMateriaux"
                                                            :summary-method="getSummCompte"
                                                            show-summary
                                                            style="width: 100%"
                                                    >

                                                        <el-table-column type="expand">
                                                          <template slot-scope="propsArticle">
                                                            <el-row class="elevation-3 pl-4 pr-4 pt-2">

                                                              <el-col :span="24">
                                                                <div class="grid-content bg-purple">

                                                                  <h4>Détails articles</h4>
                                                                  <el-table
                                                                    border
                                                                    highlight-current-row
                                                                    :header-row-style="headerRowStyle"
                                                                    :data="propsArticle.row.materiels"
                                                                    :summary-method="getSummaries"
                                                                    show-summary
                                                                    style="width: 100%"
                                                                  >
                                                                    <el-table-column prop="refProd" label="REFERENCE">
                                                                        <template
                                                                                slot-scope="prop"
                                                                        >
                                                                            <span class="subheading black--text" >{{prop.row.refProd }}</span>
                                                                        </template>
                                                                    </el-table-column>
                                                                    <el-table-column prop="designation" label="DESIGNATION"></el-table-column>
                                                                    <el-table-column prop="qte" label="QTE UTILISEE">
                                                                      <template
                                                                        slot-scope="prop"
                                                                      >{{ new Intl.NumberFormat().format(prop.row.qte)}}</template>
                                                                    </el-table-column>

                                                                      <el-table-column prop="qteSortie" label="QTE SORTIE">
                                                                          <template
                                                                                  slot-scope="prop"
                                                                          >{{ new Intl.NumberFormat().format(prop.row.qteSortie)}}</template>
                                                                      </el-table-column>

                                                                    <el-table-column prop="unite" label="UNITE"></el-table-column>
                                                                    <el-table-column prop="prixU" label="PRIX UNITAIRE">
                                                                      <template
                                                                        slot-scope="prop"
                                                                      >{{ new Intl.NumberFormat().format(prop.row.prixU)}}</template>
                                                                    </el-table-column>

                                                                    <el-table-column prop="tva" label="TVA"></el-table-column>
                                                                    <el-table-column prop="remise" label="REMISE"></el-table-column>
                                                                    <el-table-column prop="total" label="TOTAL">
                                                                      <template
                                                                        slot-scope="prop"
                                                                      >{{ new Intl.NumberFormat().format(prop.row.total)}}</template>
                                                                    </el-table-column>

                                                                  </el-table>


                                                                </div>
                                                              </el-col>
                                                            </el-row>
                                                          </template>
                                                        </el-table-column>
                                                        <el-table-column align="center" sortable  prop="libelle"
                                                                         label="LIBELLE">
                                                            <template
                                                                    slot-scope="prop"
                                                            > <span class="subheading black--text" > {{prop.row.libelle}}  </span>
                                                            </template>

                                                        </el-table-column>
                                                        <el-table-column align="center"  sortable  prop="dateD" label="DATE DEBUT">
                                                            <template
                                                                    slot-scope="prop"
                                                            >{{prop.row.dateD}}
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column align="center"  sortable  prop="dateF" label="DATE FIN">
                                                            <template
                                                                    slot-scope="prop"
                                                            >{{prop.row.dateF}}
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column align="center"  sortable  prop="chefTravaux" label="CHEF TRAVAUX">
                                                            <template
                                                                    slot-scope="prop"
                                                            >{{prop.row.chefTravaux}}
                                                            </template>
                                                        </el-table-column>

                                                    </el-table>
                                                </v-flex>
                                            </v-layout>
                                        </el-tab-pane>

                                    </el-tabs>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    //function de difference de date

    var echarts = require("echarts/lib/echarts");
    require("echarts/lib/chart/bar");
    require("echarts/lib/chart/pictorialBar");
    require("echarts/lib/chart/funnel");
    require("echarts/lib/chart/sankey");
    require("echarts/lib/chart/scatter");
    require("echarts/lib/component/tooltip");
    require("echarts/lib/component/title");
    import html2canvas from "html2canvas";
    import Loading from "@/components/Loading";

    export default {
        components: {
            Loading
        },
        name: "CompteExploitation",
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
                loading: false,
                racourcis: [
                    {path: "/compte", text: "Compte exploitation", disabled: false}
                ],

                //formulaire de recherche
                formSearch: {
                    projet: "",
                    chantier: ""
                },
                listeProjet: [],
                listeChantier: [],
                rulesForm: {},
                bilanTravaux: [],
                bilanMensuel: [],
                info: {
                    evolution: 0
                },
                activeLotTrx: "1",
                compte: "0",
                listeDetail: [],
                listeMateriaux: []
            };
        },
        computed: {
            disableBtnRecherche: function () {
                if (this.formSearch.projet == "" && this.formSearch.chantier == "") {
                    return true;
                }
            }
        },
        methods: {

            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
            format(percentage) {
                return `${percentage}%`;
            },
            getSummaries(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },

            getSummariesTache(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }
                    if (index === 4) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },
            imprimeProjetPDF () {
                let tab = []
                let url = ""

                this.bilanTravaux.forEach((element) => {
                    tab.push(element.idTravaux)
                })
                if (
                    this.formSearch.chantier != undefined &&
                    this.formSearch.chantier != ""
                ) {
                    url = this.domaine + 'compteExploit/imprimer/projet/' + this.formSearch.projet + '/' + this.user.id  + '/' + tab + '/' + this.formSearch.chantier
                } else {
                    url = this.domaine + 'compteExploit/imprimer/projet/' + this.formSearch.projet + '/' + this.user.id  + '/' + tab
                }
                
                window.open(url)
            },
            imprimerEtatProjetPDF() {
                let tab = []
                let url = ""
                if (
                    this.formSearch.chantier != undefined &&
                    this.formSearch.chantier != ""
                ) {
                    url = this.domaine + 'compteExploit/imprimer/etat/projet/' + this.formSearch.projet + '/' + this.user.id + '/' + this.formSearch.chantier
                } else {
                    url = this.domaine + 'compteExploit/imprimer/etat/projet/' + this.formSearch.projet + '/' + this.user.id
                }
                
                window.open(url)
            },
            getSumm(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    if (index === 4) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },
            getSummCompte(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },

            loadProjet() {
                let url = this.domaine + "projet/index/projet/all";

                this.loading = true;
                this.$http.get(url).then(
                    response => {
                        this.loading = false;
                        this.listeProjet = response.body.projet;
                    },
                    errRep => {
                        this.loading = false;
                        this.$message.error(
                            "Une erreur est survenue lors du chargement de la liste des projets"
                        );
                    }
                );
            },
            selectProjet(idProjet) {
                this.listeChantier.splice(0);
                this.formSearch.chantier = "";
                this.loadChantier(idProjet);
            },
            loadChantier(item) {
                this.loading = true;
                let url = this.domaine + "projet/" + item + "/index/chantier";
                this.$http.get(url).then(
                    response => {
                        this.loading = false;
                        this.listeChantier = response.body.chantier;
                    },
                    errRep => {
                        this.loading = false;
                        this.$message.error(
                            "Une erreur est survenue lors du chargement de la liste du chntier"
                        );
                    }
                );
            },
            imprimeBudgtRecapitulatifAnnuelSimpl (type) {
                 let url = "";
                    if (type == "PDF") {
                        url = this.domaine + 'budgetProjet/budget/projet/'+this.detailProjet.idProj+'/user/'+this.user.id+'/imprimerPDF_RecapitulatifAnnuelSimpl';
                    } else {
                        url = this.domaine + 'budgetProjet/budget/projet/'+this.detailProjet.idProj+'/user/'+this.user.id+'/imprimerEXC_RecapitulatifAnnuelSimpl';
                    }
                    window.open(url)
            },

            loadBilan() {
                this.loading = true;
                let url = "";

                if (
                    this.formSearch.chantier != undefined &&
                    this.formSearch.chantier != ""
                ) {
                    url =
                        this.domaine + "compteExploit/chantier/" + this.formSearch.chantier;
                } else {
                    if (
                        this.formSearch.projet != undefined &&
                        this.formSearch.projet != ""
                    ) {
                        url = this.domaine + "compteExploit/projet/" + this.formSearch.projet;
                    }
                }

                if (url == "") {
                    return;
                }
                this.$http.get(url).then(
                    response => {
                        this.loading = false;
                        this.bilanMensuel = response.body.mensuel;
                        this.bilanTravaux = response.body.bilanTravaux.travaux;
                        this.info = response.body.info;
                        this.listeDetail = response.body.detailCompte;
                        this.listeMateriaux = response.body.materiaux;
                    },
                    errRep => {
                        this.loading = false;
                        this.$message.error(
                            "Une erreur est survenue lors du chargement du bilan"
                        );
                    }
                );
            },
            handleTabClick(tab) {
                switch (tab) {
                    case "0":
                        break;
                    case "1":
                        break;

                    default:
                        break;
                }
            },

            //recherche info projet ou chantier
            submitForm() {
            }
        },

        mounted() {
            this.loadProjet();
            //this.loadBilan();
        }
    };
</script>

<style>
    tr td.el-table__expanded-cell {
        background-color:#EEEEEE;
    }



    td.el-table__expanded-cell div {
        background-color:#ffffff;
    }
</style>




// WEBPACK FOOTER //
// src/components/projet/CompteExploitation.vue